const replaceSlug = (
  slug: string,
  lookUp: Record<string, string> = {},
  exceptions: string[] = []
): string => {
  if (exceptions.length !== 0 && exceptions.includes(slug)) {
    return slug;
  }

  if (Object.keys(lookUp).length !== 0) {
    const re = new RegExp(Object.keys(lookUp).join('|'), 'gi');
    return slug.replace(re, matched => {
      return lookUp[matched.toLowerCase()];
    });
  }

  return slug;
};

export default replaceSlug;
